import React, { useState } from 'react';
import {
  Image,
  Pressable,
  StyleSheet,
  Text,
  TextInput,
  View,
} from 'react-native';
import { SelectList } from 'react-native-dropdown-select-list';

import { DraggableSheet } from '../reusable/DraggableSheet';
import { sendReport } from 'data/report';
import { Report } from 'types/reports';

const loadingIcon = require('assets/loading.gif');

const testID = 'ReportPopup';
const inputs = [
  {
    key: 'description',
    label: 'Description',
    length: 300,
  },
  {
    key: 'contact',
    label: 'Email',
    length: 50,
  },
];
const priorities = [
  {
    key: 'emergency',
    value: 'Emergency',
  },
  {
    key: 'trail',
    value: 'Blocked Trail',
  },
  {
    key: 'vandalism',
    value: 'Vandalism',
  },
  {
    key: 'wildlife',
    value: 'Wildlife',
  },
  {
    key: 'fyi',
    value: 'FYI',
  },
  {
    key: 'other',
    value: 'Other',
  },
];

function Button({ status, values, report }) {
  const disabled =
    (!values.description && !values.priority) || status === 'done';
  if (status === 'loading') {
    return (
      <Pressable
        testID={`${testID}_submit`}
        style={[styles.button, disabled ? styles.disabledButton : {}]}
        disabled={true}
      >
        <Image source={loadingIcon} style={styles.loader} />
      </Pressable>
    );
  }
  return (
    <View style={styles.submitContainer}>
      <Pressable
        testID={`${testID}_submit`}
        style={[styles.button, disabled ? styles.disabledButton : {}]}
        disabled={disabled}
        onPress={() => report(values)}
      >
        <Text style={styles.buttonText}>Submit</Text>
      </Pressable>
      {status === 'done' && <Text style={styles.doneText}>Sent!</Text>}
      {status === 'error' && (
        <Text style={styles.error}>
          An error has occurred, please try again later.
        </Text>
      )}
    </View>
  );
}

export function ReportPopup({ location, close, open }) {
  const [values, onValueChange] = useState({
    description: null,
    priority: null,
    contact: null,
  });
  const [status, setStatus] = useState(null);

  function report(data) {
    const latlng = location ? location[0] : null;
    const body: Report = { ...data, latlng };
    setStatus('loading');
    sendReport(body)
      .then(() => setStatus('done'))
      .catch(() => {
        setStatus('error');
      });
  }

  return (
    <DraggableSheet dismiss={close} testID={testID} open={open} id="report">
      <View>
        <Text testID={`${testID}_title`} style={styles.title}>
          Report an issue
        </Text>
        <View style={styles.dropDown}>
          <Text testID={`${testID}_label_priority`} style={styles.labelTitle}>
            Issue Type
          </Text>
          <SelectList
            setSelected={(val) => {
              onValueChange((e) => {
                return { ...e, ...{ priority: val } };
              });
            }}
            data={priorities}
            save="value"
          />
        </View>
        {inputs.map((input) => (
          <View key={input.key}>
            <Text
              testID={`${testID}_label_${input.label}`}
              style={styles.labelTitle}
            >
              {input.label}
            </Text>
            <TextInput
              testID={`${testID}_input_${input.label}`}
              style={styles.input}
              autoComplete={input.key === 'contact' ? 'email' : null}
              maxLength={input.length}
              onChangeText={(val) =>
                onValueChange((e) => {
                  return { ...e, ...{ [input.key]: val } };
                })
              }
            />
          </View>
        ))}

        <Button status={status} values={values} report={report} />
      </View>
    </DraggableSheet>
  );
}

const styles = StyleSheet.create({
  title: {
    fontSize: 25,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  labelTitle: {
    fontSize: 18,
    fontWeight: '600',
    marginBottom: 5,
  },
  input: {
    borderWidth: 1,
    borderColor: 'rgb(128, 128, 128)',
    borderRadius: 10,
    fontSize: 14,
    marginBottom: 10,
    paddingVertical: 12,
    paddingHorizontal: 20,
  },
  button: {
    backgroundColor: '#1e1eff',
    borderRadius: 5,
    padding: 10,
    alignSelf: 'flex-start',
  },
  disabledButton: {
    opacity: 0.5,
  },
  submitContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  buttonText: {
    color: '#fff',
    fontWeight: 'bold',
  },
  dropDown: {
    marginBottom: 10,
  },
  doneText: {
    marginLeft: 10,
    color: '#2bcd2b',
  },
  loader: {
    width: 14,
    height: 14,
  },
  error: {
    marginLeft: 10,
    color: '#e43333',
  },
});
